import { PuxButton, PuxSpinner, PuxText } from "@phonero/pux-react"
import classNames from "classnames"
export const VippsButton = (props: Parameters<typeof PuxButton>[0] & {buttonText?: React.ReactNode, showSpinner?: boolean}) => {
  const height = 50
  // Please do not change the viewbox of the svg (change the width)
  // https://developer.vippsmobilepay.com/docs/vipps-design-guidelines/buttons/  
  return (
    <PuxButton
      {...props}
      aria-label={
        (typeof props.buttonText === "string" ? props.buttonText : undefined) ??
        "Betal med"
      }
      className={classNames("btn-reset", props.className)}
      expand="block"
      color="medium"
      size="large"
      style={{
        //"--pux-color-medium-contrast": "#000000",
        "--pux-color-medium": "#FF5B24",
      }}
    >
      {!!props.showSpinner && <PuxSpinner />}
      {!props.showSpinner && (
        <>
          <PuxText color="light" style={{ fontSize: "19px" }}>
            {props.buttonText ?? "Betal med"}
          </PuxText>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="29"
            viewBox="0 0 72 29"
            fill="none"
            style={{ transform: "scale(1.1) translate(0px, -1px)" }}
          >
            <path
              d="M12.3302 9.6521L14.5761 16.1892L16.7779 9.6521H19.3761L15.5008 19.348H13.5632L9.68799 9.6521H12.3302Z"
              fill="white"
            />
            <path
              d="M25.233 17.8124C26.8623 17.8124 27.7871 17.0227 28.6678 15.882C29.1522 15.2678 29.7687 15.1362 30.2091 15.4871C30.6495 15.8381 30.6935 16.4962 30.2091 17.1104C28.9321 18.7776 27.3027 19.7867 25.233 19.7867C22.9871 19.7867 21.0054 18.5583 19.6403 16.4085C19.244 15.8381 19.3321 15.2239 19.7724 14.9168C20.2128 14.6097 20.8733 14.7413 21.2697 15.3555C22.2385 16.8033 23.5596 17.8124 25.233 17.8124ZM28.2715 12.416C28.2715 13.2058 27.655 13.7322 26.9504 13.7322C26.2458 13.7322 25.6293 13.2058 25.6293 12.416C25.6293 11.6263 26.2458 11.0999 26.9504 11.0999C27.655 11.0999 28.2715 11.6702 28.2715 12.416Z"
              fill="white"
            />
            <path
              d="M34.4806 9.65203V10.9682C35.1412 10.0469 36.154 9.38879 37.6513 9.38879C39.5448 9.38879 41.7467 10.9682 41.7467 14.3464C41.7467 17.9001 39.6329 19.6112 37.4311 19.6112C36.2861 19.6112 35.2292 19.1725 34.4366 18.0756V22.7262H32.0586V9.65203H34.4806ZM34.4806 14.4781C34.4806 16.4523 35.6256 17.5053 36.9026 17.5053C38.1357 17.5053 39.3687 16.5401 39.3687 14.4781C39.3687 12.4599 38.1357 11.4947 36.9026 11.4947C35.6696 11.4947 34.4806 12.416 34.4806 14.4781Z"
              fill="white"
            />
            <path
              d="M45.9303 9.65203V10.9682C46.5909 10.0469 47.6037 9.38879 49.101 9.38879C50.9945 9.38879 53.1964 10.9682 53.1964 14.3464C53.1964 17.9001 51.0826 19.6112 48.8808 19.6112C47.7358 19.6112 46.6789 19.1725 45.8863 18.0756V22.7262H43.5083V9.65203H45.9303ZM45.9303 14.4781C45.9303 16.4523 47.0753 17.5053 48.3523 17.5053C49.5854 17.5053 50.8184 16.5401 50.8184 14.4781C50.8184 12.4599 49.5854 11.4947 48.3523 11.4947C47.0753 11.4947 45.9303 12.416 45.9303 14.4781Z"
              fill="white"
            />
            <path
              d="M58.2606 9.38879C60.2423 9.38879 61.6514 10.3101 62.2679 12.5915L60.1101 12.9425C60.0661 11.8018 59.3615 11.4069 58.3046 11.4069C57.512 11.4069 56.8955 11.7579 56.8955 12.3283C56.8955 12.767 57.2037 13.2057 58.1285 13.3812L59.7579 13.6883C61.3432 13.9955 62.2239 15.0484 62.2239 16.4523C62.2239 18.5582 60.3303 19.6112 58.5248 19.6112C56.6312 19.6112 54.5175 18.646 54.2092 16.2768L56.367 15.9259C56.4991 17.1543 57.2478 17.593 58.4808 17.593C59.4056 17.593 60.0221 17.242 60.0221 16.6717C60.0221 16.1452 59.7138 15.7504 58.701 15.5749L57.2037 15.3116C55.6184 15.0045 54.6496 13.9077 54.6496 12.5038C54.6936 10.3101 56.6753 9.38879 58.2606 9.38879Z"
              fill="white"
            />
          </svg>
        </>
      )}
    </PuxButton>
  )
}
